import { getPrice } from '@sigma-frontend-libs/commons'

import { balance } from '@/utils'

import render from './render'

export default {
  name: 'UsersBalance',

  mixins: [ balance() ],

  props: {
    currency: {
      type: String,
      default: undefined
    }
  },

  computed: {
    $_currency() {
      return this.currency || this.globalSettings.billings.currency
    },
    $_value() {
      return getPrice(this.balance, { currency: this.$_currency })
    },
    $_label() {
      if (this.canReadOverdraft) {
        const total = this.balance + this.overdraft

        return getPrice(total, { currency: this.$_currency })
      }

      return '---'
    }
  },

  render
}
